import React from 'react';

import moment from 'moment';

import TableSortHeaderCell from 'CommonComponents/TableSortHeaderCell';

export default function ActionSummary(props) {
    const getTargetDate = (action) => {
        return action.actionable_type_name === 'Issue' ? action.actionable.resolution_date : action.actionable.target_date;
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-min-w-32">{$t('Type')}</th>
                        <th className="tw-min-w-32">{$t('Reference')}</th>
                        <th className="tw-min-w-48">{$t('Description')}</th>
                        <th className="tw-min-w-32">{$t('Owner')}</th>
                        <th className="tw-min-w-32">{$t('Status')}</th>
                        <th className="tw-min-w-32">{$t('Priority')}</th>
                        <th className="tw-min-w-32">{$t('Action')}</th>
                        <th className="tw-min-w-32">{$t('Owner')}</th>
                        <th className="tw-min-w-32" onClick={() => props.handleOrderBy('due_date')}>
                            <TableSortHeaderCell
                                asc={props.actionSummaryOrder.order_by === 'due_date' && props.actionSummaryOrder.order === 'asc'}
                                desc={props.actionSummaryOrder.order_by === 'due_date' && props.actionSummaryOrder.order === 'desc'}
                            >
                                {$t('Due Date')}
                            </TableSortHeaderCell>
                        </th>
                        <th className="tw-min-w-40" onClick={() => props.handleOrderBy('completed_date')}>
                            <TableSortHeaderCell
                                asc={props.actionSummaryOrder.order_by === 'completed_date' && props.actionSummaryOrder.order === 'asc'}
                                desc={props.actionSummaryOrder.order_by === 'completed_date' && props.actionSummaryOrder.order === 'desc'}
                            >
                                {$t('Completed Date')}
                            </TableSortHeaderCell>
                        </th>
                        <th className="tw-min-w-32">{$t('Overdue')}</th>
                    </tr>
                </thead>
                {!props.isLoading && !!props.actionSummary && (
                    <tbody>
                        {props.actionSummary.map((action) => (
                            <tr key={`action-${action.id}`}>
                                <td>
                                    {action.actionable_type_name === 'Issue'
                                        ? $t('Issue')
                                        : action.actionable_type_name === 'Decision'
                                          ? $t('Decision')
                                          : $t('Risk')}
                                </td>
                                <td>{action.actionable.id}</td>
                                <td>{action.actionable.description}</td>
                                <td>
                                    {action.actionable?.owner?.first_name} {action.actionable?.owner?.last_name}
                                </td>
                                <td>{action.actionable.status?.title}</td>
                                <td className="text-capitalize">{action.actionable.priority}</td>
                                <td>{action.description}</td>
                                <td>
                                    {action.owner?.first_name} {action.owner?.last_name}
                                </td>
                                <td className="inbud-date-cell">{action.date ? moment(action.date).format('YYYY-MM-DD') : ''}</td>
                                <td className="inbud-date-cell">{action.completed_date ? moment(action.completed_date).format('YYYY-MM-DD') : ''}</td>
                                <td>{action.overdue ? $t('Yes') : $t('No')}</td>
                            </tr>
                        ))}
                    </tbody>
                )}
                {props.isLoading && (
                    <tbody>
                        <tr>
                            <td colSpan="100">{$t('Loading')}...</td>
                        </tr>
                    </tbody>
                )}
                {!props.isLoading && !props.actionSummary && (
                    <tbody>
                        <tr>
                            <td colSpan="100">
                                <span className="mr-3 font-italic">{$t('No data found')}</span>
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
}
